import { createContext } from "react";
const AdminProFeatureContext = createContext();
export default AdminProFeatureContext;
